import React from 'react';
import closeButton from '../../resouces/arrow-back-black.svg'


export default class ModalWindow extends React.Component {

    render() {
        return (
            <div className="modalWindow">
                <img src={closeButton}
                     className="closeButton"
                     alt=''
                     onClick={() => {this.props.close()}}/>
                {this.props.children}
            </div>
        );
    }
}